module.exports = __webpack_public_path__ + "img/neobank.b5a01b0e.png";